import angular from 'angular';
import { values } from 'lodash';

module.exports = angular.module('common.filters.order-object-by', [])
.filter('orderObjectBy', function(orderByFilter) {
  return function(object, expression, reverse) {
    return orderByFilter(values(object), expression, reverse);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/order-object-by.js
 **/